export const rb2bID = process.env.NEXT_PUBLIC_RB2B_ID;
